var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer3d"},[_c('model-fbx',{attrs:{"src":"demofbx2.fbx","controlsOptions":{
          enablePan: _vm.enablePan,
          enableZoom: _vm.enableZoom,
          enableRotate: _vm.enableRotate,
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }